import axios from 'axios'

// En local, REACT_APP_API_URL est défini par bin/worktree dans .env.development.local
const rootPath = process.env.REACT_APP_API_URL || 'https://cordon.nicolasm.fr'

axios.interceptors.request.use(function (config) {
    config.headers['Authorization'] = `Bearer ${accessToken()}}`;
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

axios.interceptors.response.use(response => {
    storeAccessToken(response.headers['access-token'])
    return response;
 }, error => {
    if(error.config.method === 'post' && error.config.url.indexOf("/sessions") > -1) {
        return Promise.reject(error)
    }
    // Sans réponse (API injoignable, erreur réseau), error.response est absent
    if (error.response?.status === 401) {
        window.location.href = '/login'
    }
    return Promise.reject(error)
 });

export const login = (params: LoginParams) => axios
    .post(
        `${rootPath}/sessions`,
        params
    )

export const logout = () => {
    storeAccessToken("")
    window.location.href = '/login'
}

export const createBankTransaction = (params: CreateBankTransactionParams) => axios
    .post(
        `${rootPath}/bank_transactions`,
        {bank_transaction: params}
    )
    .then(r => r.data as BankTransaction)

export const listBankTransactions = (params: ListTransactionsParams) => axios
    .get(
        `${rootPath}/bank_transactions`,
        {params}
    )
    .then(r => r.data as BankTransaction[])

export const getStatementBalance = (account_id: number, filename: Filename) => axios
    .get(`${rootPath}/bank_transactions/statement_balance`, {params: {account_id, filename}})
    .then(r => r.data.bank_balance as BankBalance | null)

// propagate_user_label : le libellé perso renomme aussi les opérations au même libellé banque sans libellé perso
export const updateBankTransaction = (id: number, params: UpdateBankTransactionParams, propagate_user_label = false) => axios
    .put(
        `${rootPath}/bank_transactions/${id}`,
        { bank_transaction: params, propagate_user_label }
    )

export const countUserLabelMatches = (id: number) => axios
    .get(`${rootPath}/bank_transactions/${id}/user_label_matches`)
    .then(r => r.data.count as number)

export const listLinkCandidates = (id: number, q: string, account_id?: number) => axios
    .get(`${rootPath}/bank_transactions/${id}/link_candidates`, {params: {q, account_id}})
    .then(r => r.data as LinkCandidates)

// Fusionne other_id dans l'opération (ou l'inverse si other_id vient de la banque) : renvoie l'opération gardée.
export const linkBankTransactions = (id: number, other_id: number, params: {impact?: Impact, budget_id?: number | null}) => axios
    .post(`${rootPath}/bank_transactions/${id}/link`, {other_id, ...params})
    .then(r => r.data as BankTransaction)

export const addStatementLink = (id: number, account_id: number) => axios
    .post(`${rootPath}/bank_transactions/${id}/statement_links`, {account_id})
    .then(r => r.data as BankTransaction)

export const sendToTricount = (id: number, params: { tricount_id: number, label: string, member_uuids: string[] }) => axios
    .post(`${rootPath}/bank_transactions/${id}/tricount_entry`, params)
    .then(r => r.data as BankTransaction)

export const destroyStatementLink = (id: number, statement_link_id: number) => axios
    .delete(`${rootPath}/bank_transactions/${id}/statement_links/${statement_link_id}`)
    .then(r => r.data as BankTransaction)

export const destroyBankTransaction = (id: number) => axios
    .delete(`${rootPath}/bank_transactions/${id}`)


export const listBudgets = () => axios
    .get(`${rootPath}/budgets`)
    .then(r => r.data.sort((a: Budget, b: Budget) => a.id - b.id) as Budget[])

export const listBudgetImpacts = () => axios
    .get(`${rootPath}/budgets/stats`)
    .then(r => r.data as BudgetImpact[])

export const insertBudget = (params: BudgetParams) => axios
    .post(
        `${rootPath}/budgets`,
        { budget: params }
    )
    .then(r => r.data as Budget)

export const updateBudget = (id: number, params: BudgetParams) => axios
    .put(
        `${rootPath}/budgets/${id}`,
        { budget: params }
    )
    .then(r => r.data as Budget)

export const destroyBudget = (id: number) => axios
    .delete(`${rootPath}/budgets/${id}`)


export const listAccounts = () => axios
    .get(`${rootPath}/accounts`)
    .then(r => r.data as Account[])

export const createAccount = (params: AccountParams) => axios
    .post(`${rootPath}/accounts`, { account: params })
    .then(r => r.data as Account)

export const updateAccount = (id: number, params: AccountParams) => axios
    .put(`${rootPath}/accounts/${id}`, { account: params })
    .then(r => r.data as Account)

export const applyAccountDefaultImpact = (id: number) => axios
    .post(`${rootPath}/accounts/${id}/apply_default_impact`)
    .then(r => r.data as { updated_count: number })

export const updateAccountPositions = (ids: number[]) => axios
    .put(`${rootPath}/accounts/positions`, { ids })

export const destroyAccount = (id: number) => axios
    .delete(`${rootPath}/accounts/${id}`)

export const listBankConnections = () => axios
    .get(`${rootPath}/bank_connections`)
    .then(r => r.data as BankConnection[])

export const searchAspsps = (q: string) => axios
    .get(`${rootPath}/bank_connections/aspsps`, {params: {q}})
    .then(r => r.data as string[])

export const startBankConnection = (aspsp_name: string) => axios
    .post(`${rootPath}/bank_connections`, {aspsp_name})
    .then(r => r.data.url as string)

export const syncBankConnection = (id: number) => axios
    .post(`${rootPath}/bank_connections/${id}/sync`)
    .then(r => r.data as BankTransaction[])

export const updateBankAccount = (id: number, params: BankAccountParams) => axios
    .put(
        `${rootPath}/bank_accounts/${id}`,
        { bank_account: params }
    )
    .then(r => r.data as BankAccount)

export const previewBankAccountFiling = (id: number, params: BankAccountParams) => axios
    .post(`${rootPath}/bank_accounts/${id}/filing_preview`, { bank_account: params })
    .then(r => r.data.preview as FilingPreview | null)

export const listTricounts = () => axios
    .get(`${rootPath}/tricounts`)
    .then(r => r.data as Tricount[])

export const createTricount = (link: string) => axios
    .post(`${rootPath}/tricounts`, {link})
    .then(r => r.data as Tricount)

export const updateTricount = (id: number, params: TricountParams) => axios
    .put(`${rootPath}/tricounts/${id}`, {tricount: params})
    .then(r => r.data as Tricount)

export const previewTricountFiling = (id: number, params: TricountParams) => axios
    .post(`${rootPath}/tricounts/${id}/filing_preview`, { tricount: params })
    .then(r => r.data.preview as FilingPreview | null)

export const destroyTricount = (id: number) => axios
    .delete(`${rootPath}/tricounts/${id}`)

export const syncTricount = (id: number) => axios
    .post(`${rootPath}/tricounts/${id}/sync`)
    .then(r => r.data as BankTransaction[])

// Message d'erreur renvoyé par l'API (« Lien Tricount invalide… »), sinon le message par défaut.
export const apiErrorMessage = (error: any, fallback: string) => error?.response?.data?.message || fallback

const storeAccessToken = (auth_token: string) => {
    localStorage.setItem('access_token', auth_token)
}


const accessToken = () => localStorage.getItem('access_token')

